import { DateTime } from 'luxon';
import { monthsArray } from './YearView.constants';
import { IMonthCellConfig } from './YearView.types';
import {
  getCalendarMonthRange,
  getFirstDayOfMonthFromDate,
} from '../../../../../BKJDatePicker.utils';
import { ISO8601TupleType } from 'types/common.types';
import {
  BKJDatePickerOnChangeType,
  BKJDatePickerValueType,
} from '../../../../../BKJDatePicker.types';
import { MonthNameType } from '../../BKJCalendar.types';
import { useTranslation } from 'hooks/useTranslation';

export const getMonthCellsConfigArray = ({
  value,
  name,
  year,
  onChange,
}: {
  value: BKJDatePickerValueType;
  name: string;
  year: number;
  onChange: BKJDatePickerOnChangeType;
}): Array<IMonthCellConfig> =>
  monthsArray.map((monthName: MonthNameType) => {
    const { t } = useTranslation();
    const firstDayOfMonth = DateTime.fromFormat(`${monthName}, ${year}`, 'LLLL, yyyy')
      .startOf('month')
      .toString();
    const firstDayOfSelectedDateRange = getFirstDayOfMonthFromDate(value[0]);
    const _value = getCalendarMonthRange(firstDayOfMonth);
    const isMonthThisMonth = DateTime.fromISO(firstDayOfMonth).hasSame(DateTime.now(), 'month');
    const isSelected = DateTime.fromISO(firstDayOfMonth).hasSame(
      DateTime.fromISO(firstDayOfSelectedDateRange),
      'day',
    );
    const handleMonthClick = (): void => {
      const e = {
        target: {
          name,
          value: _value,
        },
      };
      return onChange(e);
    };

    return {
      label: t(monthName.toUpperCase()),
      onClick: handleMonthClick,
      isMonthThisMonth: isMonthThisMonth,
      isSelected: isSelected,
    };
  });

export const getYearInView = (dateRangeInMonthView: ISO8601TupleType): number =>
  DateTime.fromISO(dateRangeInMonthView[0]).plus({ months: 1 }).get('year');
